import { trpc, TrpcInputs, TrpcOutputs } from '../../config/trpc';
import { MutateFunction, UseMutateResource } from '../../utils/types';

type FlightSegmentInput = TrpcInputs['updateFlightSegment'];
type FlightSegmentOutput = TrpcOutputs['updateFlightSegment'];

type MutateFlightSegment = MutateFunction<FlightSegmentInput, FlightSegmentOutput>;
type UseUpdateFlightSegment = UseMutateResource<MutateFlightSegment>;

export const useUpdateFlightSegment = (id: number): UseUpdateFlightSegment => {
  const { mutateAsync, isLoading, error } = trpc.updateFlightSegment.useMutation();

  const mutate: MutateFlightSegment = (args) => mutateAsync({ id, ...args } as FlightSegmentInput);

  return [mutate, isLoading, error?.message];
};
